"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatorTemplate = void 0;
var _react = _interopRequireDefault(require("react"));
var _LabelAndLogo = _interopRequireDefault(require("./LabelAndLogo"));
var _TitleAndDescriptions = _interopRequireDefault(require("./TitleAndDescriptions"));
var _SideContent = _interopRequireDefault(require("./SideContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-tabs */

/**
 * CalculatorTemplate is a functional component that will take care of rendering a conditional border, a conditional Label/Logo combo,
 * a conditional Title and/or Description and lasty a condtional SideContent column.
 * @param {object} config Main JSON config provided to the Calculator components
 * @param {object} currentConfig Specifically just the config info realated to the current step of the calc\
 * @param {string} defaultTitle The title to use if none is provided in config
 * @returns The conditional content as described above, and returns all of it's children within the conditional content
 */
var CalculatorTemplate = _ref => {
  var _currentConfig$SideCo, _currentConfig$SideCo2;
  var {
    children,
    config,
    currentConfig,
    defaultTitle,
    stepNumber,
    customSideContent
  } = _ref;
  var iconString = config === null || config === void 0 ? void 0 : config.Icon;
  var labelString = config === null || config === void 0 ? void 0 : config.Label;
  var showLabelAndIcon = iconString && labelString;
  var secondaryStyle = config === null || config === void 0 ? void 0 : config.SecondaryStyle;
  var hasBorder = config === null || config === void 0 ? void 0 : config.HasBorder;
  var validSiteContent = (currentConfig === null || currentConfig === void 0 || (_currentConfig$SideCo = currentConfig.SideContent) === null || _currentConfig$SideCo === void 0 ? void 0 : _currentConfig$SideCo.Title) || (currentConfig === null || currentConfig === void 0 || (_currentConfig$SideCo2 = currentConfig.SideContent) === null || _currentConfig$SideCo2 === void 0 ? void 0 : _currentConfig$SideCo2.Description);
  var currentCustomSideContent = customSideContent ? customSideContent[stepNumber] : null;
  var isForcedSingleColumnLayout = config === null || config === void 0 ? void 0 : config.isForcedSingleColumnLayout;
  var labelAndLogo = /*#__PURE__*/_react.default.createElement(_LabelAndLogo.default, {
    iconString: iconString,
    labelString: labelString
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "archetype".concat(hasBorder ? ' calcBorder' : '').concat(secondaryStyle ? ' secondaryStyle' : '')
  }, showLabelAndIcon && !secondaryStyle && labelAndLogo, /*#__PURE__*/_react.default.createElement("div", {
    className: "row null-x-margin"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col left-col"
  }, showLabelAndIcon && secondaryStyle && labelAndLogo, /*#__PURE__*/_react.default.createElement(_TitleAndDescriptions.default, {
    title: currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.Title,
    defaultTitle: defaultTitle,
    description: currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.Description,
    secondaryDescription: currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.SecondaryDescription
  }), children), (validSiteContent || currentCustomSideContent) && /*#__PURE__*/_react.default.createElement(_SideContent.default, {
    currentConfig: currentConfig,
    customSideContent: currentCustomSideContent,
    isForcedSingleColumnLayout: isForcedSingleColumnLayout,
    secondaryStyle: secondaryStyle
  })));
};
exports.CalculatorTemplate = CalculatorTemplate;